module.exports = __webpack_public_path__ + "img/flags/KP.3bd86b3.png";